import { render, staticRenderFns } from "./BlogWidget.vue?vue&type=template&id=02634066"
import script from "./BlogWidget.vue?vue&type=script&lang=js"
export * from "./BlogWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports